class WeglotSwitcher extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.weglot-switcher__toggle');
    this.list = this.querySelector('.weglot-switcher__list');
    this.currentFlag = this.querySelector('[data-weglot-current-flag]');
    this.options = this.querySelectorAll('[data-weglot-lang]');

    this.toggle.addEventListener('click', this.onToggleClick.bind(this));
    this.options.forEach((option) => option.addEventListener('click', this.onOptionClick.bind(this)));
    document.addEventListener('click', this.onDocumentClick.bind(this));

    if (window.Weglot) {
      window.Weglot.on('initialized', this.syncCurrentFlag.bind(this));
      window.Weglot.on('languageChanged', this.syncCurrentFlag.bind(this));
    }
  }

  onToggleClick(event) {
    event.stopPropagation();
    const isOpen = this.list.hidden === false;
    this.list.hidden = isOpen;
    this.toggle.setAttribute('aria-expanded', String(!isOpen));
  }

  onOptionClick(event) {
    const lang = event.currentTarget.dataset.weglotLang;
    if (window.Weglot) {
      window.Weglot.switchTo(lang);
    }
    this.closeList();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeList();
    }
  }

  closeList() {
    this.list.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
  }

  syncCurrentFlag() {
    const currentLang = window.Weglot.getCurrentLang();
    const match = this.querySelector(`[data-weglot-lang="${currentLang}"] img`);
    if (match) {
      this.currentFlag.src = match.src;
    }
  }
}

customElements.define('weglot-switcher', WeglotSwitcher);
